module.exports = __webpack_public_path__ + "img/exclamation.b65a49f7.svg";